import { createLink } from '@tanstack/react-router'
import { cn } from '@workspace/ui/lib/utils'
import type { ComponentProps } from 'react'
import { forwardRef } from 'react'

/** Orange link. Type-safe TanStack Router link. */
export const CellLink = createLink(
  forwardRef<HTMLAnchorElement, ComponentProps<'a'>>(({ className, ...props }, ref) => (
    <a ref={ref} className={cn('text-[#f97316] hover:underline', className)} {...props} />
  ))
)
